// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"112":"69b06fe0","955":"a61bdeb2"}[chunkId] + ".chunk.css";
};